import { render, staticRenderFns } from "./StrandGameStatisticsScreen.vue?vue&type=template&id=01a41a15&scoped=true&"
import script from "./StrandGameStatisticsScreen.vue?vue&type=script&lang=js&"
export * from "./StrandGameStatisticsScreen.vue?vue&type=script&lang=js&"
import style0 from "./StrandGameStatisticsScreen.vue?vue&type=style&index=0&id=01a41a15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a41a15",
  null
  
)

export default component.exports